module.exports = __webpack_public_path__ + "img/zjr.54756caf.png";